import {Observable} from "rxjs/internal/Observable";
import Events from "../service/events";
import EVENTS from "../constants/events";
let debounce = require('lodash.debounce');

export interface Viewport {
    width: number,
    height: number,
}

export class ViewportService {

    protected state:string;
    protected viewport:Viewport;
    public events: Events;

    protected breakpoints:any = {
        mobile: 0,
        large_mobile: 768,
        tablet: 980,
        desktop: 1024,
        medium_desktop: 1150
    }

    constructor(events:Events) {
        this.events = events;
    }

    protected getViewport() {
        var e:any = window;
        var a:string = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width: e[a + 'Width'], height: e[a + 'Height'] };
    }

    start = () => {
        this.viewport = this.getViewport();
        this.state = this.breakpointBySize(this.viewport.width);
        this.observeViewport().subscribe(this.handleUpdate);
        this.events.emit(EVENTS.VIEWPORT_RESIZE, this.viewport);
        this.events.emit(EVENTS.VIEWPORT_CHANGE, this.state);
    }

    handleUpdate = (size:Viewport) => {
        this.viewport = size;
        this.events.emit(EVENTS.VIEWPORT_RESIZE, size)
        let breakpoint = this.breakpointBySize(size.width);
        if (breakpoint !== this.state) {
            this.state = breakpoint;
            this.events.emit(EVENTS.VIEWPORT_CHANGE, breakpoint)
        }
    };

    protected observeViewport = () => new Observable(observer => <any>$(window).on('resize', debounce(() => observer.next(this.getViewport()))));
    protected breakpointBySize = (width:number) => Object.keys(this.breakpoints).filter((key) => width >= this.breakpoints[key]).pop();
}